import * as React from "react";
import * as ReactDOM from "react-dom";

import {IApplicationStoreState, applicationStore} from '../stores/ApplicationStore'
import {ActionCreator} from '../actions/ActionCreator';

export default class Navigation extends React.Component<any, IApplicationStoreState> {

    constructor() {
        super();

        this.state = applicationStore.getState();
        
        this.searchClick = this.searchClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.toggleResponses = this.toggleResponses.bind(this);
    }

    toggleResponses(e: any) {
        e.preventDefault();
        
        ActionCreator.toggleSendResponses(this.state.merchantId, this.state.terminalId, !this.state.sendResponses);
    }

    searchClick(e: any) {
        e.preventDefault();
        
        let merchantId = ReactDOM.findDOMNode<HTMLInputElement>(this.refs['merchantId']);
        let terminalId = ReactDOM.findDOMNode<HTMLInputElement>(this.refs['terminalId']);
        
        ActionCreator.identitySelection(merchantId.value, terminalId.value);
    }
    
    componentDidMount() {
        applicationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        applicationStore.removeChangeListener(this.onChange);
    }

    onChange() {
        this.setState(applicationStore.getState());
    }

    handleTabClick(isCommunication: boolean) {
        this.props.onTabChange(isCommunication);
    }

    render() {
        let navigationHeaderPart: any;
        if (!this.state.isSelected) {
            navigationHeaderPart = <span className="lead text-danger"><strong>Select MerchantId and TerminalId</strong></span>
        } else {
            navigationHeaderPart = ` MerchantId: ${this.state.merchantId}, TerminalId: ${this.state.terminalId}`;
        }
        
        var turnButtonClassName = 'btn-danger';
        if (!this.state.sendResponses) {
            turnButtonClassName = 'btn-success';
        }
        
        return (
            <nav className="navbar navbar-default navbar-pf" role="navigation">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                    <span className="navbar-brand"><strong>NCR GiftCard Processor</strong><br/>{navigationHeaderPart}</span>
                </div>
                <div className="collapse navbar-collapse">
                    <form className="navbar-form navbar-utility" role="search">
                    { 
                        this.state.isSelected ?
                        (
                            <div className="form-group">
                                <label className="navbar-text">
                                    {this.state.sendResponses ? 'Responses are ON' : 'Responses are OFF'}
                                </label>
                                <button style={{marginRight: '5px', marginLeft: '5px'}} 
                                        type='' 
                                        className={'btn ' + turnButtonClassName}
                                        title="Turn Off/On all responses for this merchant - testing TOR" 
                                        onClick={this.toggleResponses}>
                                    {this.state.sendResponses ? 'Turn Off - Responses' : 'Turn On Responses'}
                                </button>
                            </div>
                        ) : ""
                    }
                        <div className="form-group">
                            <span className="navbar-text">Merchant Id</span>
                            <input type="text" className="form-control" placeholder="MerchantID" ref="merchantId" />
                        </div>
                        <div className="form-group">
                            <span className="navbar-text">Terminal Id</span>
                            <input type="text" className="form-control" placeholder="TerminalID" ref="terminalId"/>
                        </div>
                        <button style={{ marginLeft: "5px" }} type="submit" className="btn btn-default" onClick={this.searchClick}>Search</button>
                    </form>
                    <ul className="nav navbar-nav navbar-primary">
                        <li className={this.props.isCommunicationActive ? 'active': ''}
                            onClick={this.handleTabClick.bind(this, true)}>
                            <a>Communication</a>
                        </li>
                        <li className={!this.props.isCommunicationActive ? 'active': ''}
                            onClick={this.handleTabClick.bind(this, false)}>
                            <a>Configuration</a>
                        </li>
                    </ul>
                </div>
            </nav>);
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/Navigation.tsx